@if (popupVisibility) {
  <div class="popup">
    <div class="modal-content">
      <div class="header">
        <div class="modal-title">Session Timeout Warning</div>
      </div>
      <div class="body">
        <div class="appTimeout">
          Your session will expire in
          <div class="expireTime" [ngClass]="{'warning': time <= 31000 }">
            {{time | milisecondsToMinutes}}<span>:</span>{{time | milisecondsToSeconds}}
          </div>
        </div>
      </div>
      <div class="button-container">
        <button type="button" class="btn btn-light pull-right" (click)="logout()">Log Out</button>
        <button type="button" #okButton class="btn btn-primary pull-right" (click)="continueSession()">Continue Session</button>
      </div>
    </div>
  </div>
}
